import styled from 'styled-components'

export const PaginationButton = styled.span`
  border: 1px solid ${({theme}) => theme.primary};
  color: ${({theme}) => theme.primary};
  padding: .5rem 1rem;
  margin: .5rem;
  cursor: default;
  
  &:first-of-type {
    margin-left: 0;
  }
  
  &:last-of-type {
    margin-right: 0;
  }
`
